import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import Radium from 'higher-order-components/configured-radium/'

/** Renders a text based toggle button */
class TextToggle extends PureComponent {
  static propTypes = {
    noPadding: PropTypes.bool,
    focus: PropTypes.bool,
    active: PropTypes.bool,
    option: PropTypes.string,
    ignoreUppsercase: PropTypes.bool,
    innerRef: PropTypes.func
  }
  /**
   * @param {String} icon - URL for icon asset.
   * @returns {ReactElement} React Component
   */
  render() {
    return (
      <div
        ref={this.props.innerRef}
        data-test="text-toggle"
        style={[
          styles.base(this.props.ignoreUppsercase),
          this.props.focus && styles.focus,
          !this.props.noPadding && { margin: '0 1em' },
          this.props.active && styles.active
        ]}>
        {this.props.option}
      </div>
    )
  }
}

export default Radium(TextToggle)

const styles = {
  base: ignoreUppsercase => ({
    display: 'inline-block',
    textTransform: ignoreUppsercase ? 'none' : 'uppercase',
    letterSpacing: '.2em',
    fontWeight: '600',
    fontSize: '81%',
    color: '#aaa'
  }),
  active: {
    color: '#191919'
  },
  focus: {
    textDecoration: 'underline'
  }
}



// WEBPACK FOOTER //
// ./src/containers/text-toggle/index.jsx